import myAxios from "@/utils/request";
export default {
  // 登录
  loginUser(params) {
    return myAxios.post("/api/user/gettoken", params);
  }
};
